import { Activity, BookOpenCheck, Brain, FileCheck2, Flower2, Landmark, Languages, MapPinned, PawPrint, Scissors, ShieldCheck } from "lucide-react";
import type { CourseId } from "./types";

type VisualCourseId = CourseId | "license-support";

export function CourseCardVisual({ courseId }: { courseId: VisualCourseId }) {
  const content: Record<VisualCourseId, { primary: typeof Activity; secondary: typeof Activity }> = {
    "massage-ce-12": { primary: BookOpenCheck, secondary: Activity },
    "cosmetology-ce-4": { primary: Scissors, secondary: ShieldCheck },
    "mblex-prep": { primary: Brain, secondary: Languages },
    "new-york-prep": { primary: Landmark, secondary: BookOpenCheck },
    "hawaii-prep": { primary: Flower2, secondary: BookOpenCheck },
    "texas-prep": { primary: MapPinned, secondary: ShieldCheck },
    "texas-cosmetology-prep": { primary: Scissors, secondary: BookOpenCheck },
    "texas-esthetician-prep": { primary: Flower2, secondary: ShieldCheck },
    "texas-barber-prep": { primary: Scissors, secondary: ShieldCheck },
    "professional-dog-grooming": { primary: PawPrint, secondary: Scissors },
    "license-support": { primary: FileCheck2, secondary: ShieldCheck },
  };
  const { primary: Primary, secondary: Secondary } = content[courseId];
  return <div className={`course-card-visual course-card-visual-${courseId}`} aria-hidden="true"><Primary /><Secondary /><i /><i /></div>;
}
